import React from "react";

const NotFound = () => {
  return (
    <div className="w-full h-100vh">
      <img
        style={{ width: "100%", height: "89vh" }}
        src="not-found.jpg"
        alt="404 Page Not Found"
      />
    </div>
  );
};

export default NotFound;
